import styled from "styled-components";

export const TecladoNumericoContainer = styled.div`
  width: 100%;
  .hg-button {
    height: 50px;
    border-bottom: 0 !important;
  }

  ${({ modeLight }) =>
    modeLight &&
    ` .hg-theme-default{
    background-color: var(--color-latex10);
  }`}

  .hg-white {
    background-color: var(--color-white);
    color: var(--color-latex10);
  }
  .hg-white:active {
    background-color: var(--color-grey65);
  }
  .hg-latex10 {
    background-color: var(--color-latex10);
    color: var(--color-white);
  }
  .hg-latex10:active {
    background-color: var(--color-white);
    color: var(--color-latex10);
  }

  .hg-button.hg-danger {
    background-color: var(--color-danger) !important;
    color: var(--color-white) !important;
  }
  .hg-button.hg-danger:active {
    background-color: var(--color-white) !important;
    color: var(--color-latex10) !important;
  }

  .hg-button.hg-broccoli {
    background-color: var(--color-broccoli) !important;
    color: var(--color-white) !important;
  }
  .hg-button.hg-broccoli:active {
    background-color: var(--color-white) !important;
    color: var(--color-latex10) !important;
  }
`;
